
var getUA = require('@dp/util-m-ua');
var environment = getUA();

// 环境判断
var UA = (navigator.userAgent).toLowerCase(),
    isAndroid = /android/.test(UA),
    isIOS = /(iphone|ipad)/.test(UA),
    isAppNew = /com\.dianping/.test(UA),
    isAppOld = /efte/.test(UA) || /product\=dpapp/.test(location.search),
    isDPApp = isAppOld || isAppNew,
    isWedApp = /com\.dianping\.wed/.test(UA) || /com\.dianping\.ba\.wed/.test(UA),
    isWeixin = /micromessenger/.test(UA),
    isMTApp = (environment.type == 'mtgroup'),
    isApp = isMTApp || isDPApp,
    isDPM = /dianping\.com/ig.test(location.host) || /51ping/ig.test(location.host);

module.exports = {
    isAn: isAndroid,
    isIOS: isIOS,
    isWX: isWeixin,
    isMTApp: isMTApp,
    isDPApp: isDPApp,
    isDPM: isDPM,
    isApp: isApp,
    isBeta: {
        dp: /51ping/ig.test(location.host),
        mt: /test/ig.test(location.host)
    }
};


// WEBPACK FOOTER //
// ./src/lib/env.js